import appConfig from 'app/config/client';

export const getBackendPath = () => {
  return appConfig.environment.apiUrl;
};
